import { faBuilding, faCity, faUser, faPeopleGroup, faCarBuilding } from "@fortawesome/pro-regular-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

export enum Classifier {
    COMPANY = "COMPANY",
    BUILDING = "BUILDING",
    PERSON = "PERSON",
    PUBLIC_COMPANY = "PUBLIC_COMPANY",
    ASSOCIATION = "ASSOCIATION"
}

export const classifierIcons: { [key in Classifier]: IconProp } = {
    [Classifier.COMPANY]: faBuilding,
    [Classifier.PERSON]: faUser,
    [Classifier.BUILDING]: faCarBuilding,
    [Classifier.PUBLIC_COMPANY]: faCity,
    [Classifier.ASSOCIATION]: faPeopleGroup
};
